import React from 'react';

import Header from '../../components/Header/Header';
import AuthPage from '../../components/AuthPage/AuthPage';
import MainPage from '../../components/MainPage/MainPage';
import { useAuth } from '../../hooks/useAuth';
import classes from './Layout.module.css';

const Layout = () => {
  const { user, loading, login, register, logout } = useAuth();

  if (loading) {
    return (
      <div className={classes.layoutContainer}>
        <Header />
        <main className="app-main">
          <p>Loading...</p>
        </main>
      </div>
    );
  }

  return (
    <div className={classes.layoutContainer}>
      <Header userEmail={user?.email} onLogout={user ? logout : null} />
      <main className="app-main">
        {user ? (
          <MainPage user={user} onLogout={logout} />
        ) : (
          <AuthPage onLogin={login} onRegister={register} />
        )}
      </main>
    </div>
  );
};

export default Layout;


